var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19 9.17715V10.0051C18.9989 11.9459 18.3704 13.8344 17.2084 15.3888C16.0463 16.9432 14.413 18.0804 12.5518 18.6307C10.6907 19.1809 8.70153 19.1149 6.88102 18.4423C5.06051 17.7697 3.50619 16.5266 2.44986 14.8985C1.39354 13.2704 0.891812 11.3444 1.01951 9.40783C1.14721 7.47126 1.89749 5.62784 3.15845 4.15252C4.41942 2.67719 6.12351 1.649 8.01657 1.22128C9.90963 0.79357 11.8902 0.989255 13.663 1.77915",
    stroke: "#389AF4",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19 2.80518L9.99999 11.8142L7.29999 9.11417",
    stroke: "#389AF4",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.c6e1abb28d7f585408fc253a402bd7b1.svg";
export { ForwardRef as ReactComponent };